import React from "react";
import { Panel } from "../../components/ui/dashboard";

const CurrentTrip: React.FC = () => {
  return (
    <div className="p-4 md:p-6">
      <Panel title="Current Trip" subtitle="Pickup, delivery, and item details">
        <ul className="text-sm text-slate-700 space-y-1">
          <li>LR: TT-2026-00231</li>
          <li>Pickup: Kisan Agro Warehouse, Nashik</li>
          <li>Delivery: Metro Retail Hub, Pune</li>
          <li>Items: 24 boxes · 860 kg</li>
        </ul>
      </Panel>
    </div>
  );
};

export default CurrentTrip;